var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-container video-con-l big"},[(_vm.isLogin && _vm.isclickedPlay)?_c('div',{staticStyle:{"width":"687px","height":"400px"},attrs:{"id":"video1"}}):_c('div',{class:{
      'video-con-l': true,
      por: true,
      small: _vm.isHome,
      big: _vm.isSYKT,
    }},[_c('img',{staticClass:"pic",attrs:{"src":_vm.item.bigimagehttpurl,"alt":""}}),_c('div',{staticClass:"video-con-l-con poa txt-overflow"},[_c('img',{staticClass:"player",attrs:{"src":require("../assets/images/player.png"),"alt":""},on:{"click":function($event){return _vm.play()}}}),_c('span',[_vm._v(_vm._s(_vm.item.videoTitle))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }